import { ajaxJson } from 'imports/ajax';
import { map2ChatObj, map2ForumUserObj } from 'imports/mapper';
import { chatActionsCreators } from 'db/chat/chat.action'
import { ForumUserActionCreators } from 'db/user/user.action'
import { createTypes } from 'redux-create-types';


const namespace = 'chat-list';

export const notifListActions = createTypes([
    'toggleSpinner',
    'setError',
    'setNotifList',
    'setNotifsCount',
    'setTotalPages',
    'setNotifList',
    'setCurrentPage',
], namespace);


function setCurrentPage(currentPage) {
    return dispatch => {
        dispatch({
            type: notifListActions.setCurrentPage,
            payload: currentPage,
        })
    }
}

function setTotalPages(totalPages) {
    return dispatch => {
        dispatch({
            type: notifListActions.setTotalPages,
            payload: totalPages,
        })
    }
}


function setNotifsCount(notifsCount) {
    return dispatch => {
        dispatch({
            type: notifListActions.setNotifsCount,
            payload: notifsCount,
        })
    }
}



function setNotifList(notifs) {
    return dispatch => {
        dispatch({
            type: notifListActions.setNotifList,
            payload: notifs
        })
    }
}


function showSpinner() {
    return dispatch => {
        dispatch({
            type: notifListActions.toggleSpinner,
            payload: true,
        });
    }
}

function hideSpinner() {
    return dispatch => {
        dispatch({
            type: notifListActions.toggleSpinner,
            payload: false,
        });
    }
}

function getNotificationsApiSuccess(res) {
    return dispatch => {
        dispatch(setNotifList(res.data.results));
        dispatch(setTotalPages(res.data.total_pages));
        dispatch(setNotifsCount(res.data.count));
        return dispatch(hideSpinner());
    }
}

function getNotificationsFromApi() {
    return (dispatch, getState) => {
        dispatch(showSpinner())
        let state = getState()
        let currentPage = state.ui.NotificationsPage.currentPage
        return ajaxJson.get('/users/site_notifications', { params: { page: currentPage } })
            .then(
                res => dispatch(getNotificationsApiSuccess(res)),
                err => dispatch(getNotificationsApiFail(err))
            )
    }
}


function getNotificationsApiFail(err) {
    return dispatch => {
        dispatch({
            type: notifListActions.setError,
            payload: err,
        })
        return dispatch(hideSpinner());
    }
}


export const notificationsActionCreators = {
    getNotificationsFromApi,
    setCurrentPage
} 
